import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "margin-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_RepairWorkMap = _resolveComponent("RepairWorkMap")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_WorkList = _resolveComponent("WorkList")!
  const _component_IncidentList = _resolveComponent("IncidentList")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Skeleton, {
        key: 0,
        "is-combined-mode": _ctx.isCombinedMode
      }, null, 8 /* PROPS */, ["is-combined-mode"]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_RepairWorkMap)
        ]),
        (_ctx.isCombinedMode)
          ? (_openBlock(), _createBlock(_component_Tabs, {
              key: 0,
              works: _ctx.works,
              "work-total-count": _ctx.works.total,
              "incident-total-count": _ctx.incidents.total,
              "is-show-c-w": _ctx.isShowCW,
              "is-show-incident": _ctx.isShowIncident,
              onChangeTab: _ctx.onChangeTab
            }, null, 8 /* PROPS */, ["works", "work-total-count", "incident-total-count", "is-show-c-w", "is-show-incident", "onChangeTab"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Filter, {
          count: ((_ctx.isCombinedMode && _ctx.isShowCW) || !_ctx.isCombinedMode) ? _ctx.works.searchTotal : _ctx.incidents.searchTotal,
          "is-show-c-w": _ctx.isShowCW,
          filters: _ctx.store.filters,
          onApplyFilter: _ctx.onApplyCwFilter,
          onResetFilter: _ctx.onResetCwFilter
        }, null, 8 /* PROPS */, ["count", "is-show-c-w", "filters", "onApplyFilter", "onResetFilter"]),
        _createCommentVNode(" Vue список для строительных работ "),
        (((_ctx.isCombinedMode && _ctx.isShowCW) || !_ctx.isCombinedMode))
          ? (_openBlock(), _createBlock(_component_WorkList, {
              key: 1,
              ref: "workListRef",
              "initial-works": _ctx.works.list || [],
              "initial-total": _ctx.works.total,
              "is-archive-mode": _ctx.isArchiveMode,
              count: 20,
              "onUpdate:total": _ctx.onUpdateWorkTotal
            }, null, 8 /* PROPS */, ["initial-works", "initial-total", "is-archive-mode", "onUpdate:total"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Vue список для инцидентов "),
        (_ctx.isCombinedMode && _ctx.isShowIncident)
          ? (_openBlock(), _createBlock(_component_IncidentList, {
              key: 2,
              ref: "incidentListRef",
              "initial-incidents": _ctx.incidents.list || [],
              "initial-total-count": _ctx.incidents.total,
              "show-title": false,
              count: 20,
              "link-search": "/incident/ajax-incidents/current?page=1",
              "onUpdate:total": _ctx.onUpdateIncidentTotal
            }, null, 8 /* PROPS */, ["initial-incidents", "initial-total-count", "onUpdate:total"]))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
}